/* import __COLOCATED_TEMPLATE__ from './upsell-content-card.hbs'; */
var _class, _descriptor;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
// eslint-disable-next-line dashboard/use-utilities-window
import theWindow from 'ember-window-mock';
export let State = /*#__PURE__*/function (State) {
  State[State["GetStarted"] = 0] = "GetStarted";
  State[State["LearnMore"] = 1] = "LearnMore";
  State[State["Error"] = 2] = "Error";
  return State;
}({});
const TOS_LINK = 'https://squareup.com/campaign/instant-payouts-terms';
let BankingInstantPayoutsUpsell = (_class = class BankingInstantPayoutsUpsell extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _defineProperty(this, "State", State);
  }
  get state() {
    // TODO @jmah: state will be determined from calling endpoint
    return this.args.state ?? State.GetStarted;
  }
  get termsOfService() {
    switch (this.state) {
      case State.GetStarted:
        return this.intl.t('banking.instantPayouts.settings.content.tos.getStarted', {
          termsOfServiceLink: TOS_LINK,
          htmlSafe: true
        });
      case State.LearnMore:
        return this.intl.t('banking.instantPayouts.settings.content.tos.learnMore', {
          termsOfServiceLink: TOS_LINK,
          htmlSafe: true
        });
      case State.Error:
        return null;
    }
  }
  get description() {
    switch (this.state) {
      case State.GetStarted:
      case State.LearnMore:
        return this.intl.t('banking.instantPayouts.settings.content.description');
      case State.Error:
        return this.intl.t('banking.instantPayouts.settings.content.error.description');
    }
  }
  get heading() {
    switch (this.state) {
      case State.GetStarted:
      case State.LearnMore:
        return this.intl.t('banking.instantPayouts.settings.content.heading');
      case State.Error:
        return this.intl.t('banking.instantPayouts.settings.content.error.heading');
    }
  }
  get buttonCta() {
    switch (this.state) {
      case State.GetStarted:
        return this.intl.t('banking.instantPayouts.settings.content.button.getStarted');
      case State.LearnMore:
        return this.intl.t('banking.instantPayouts.settings.content.button.learnMore');
      case State.Error:
        return this.intl.t('banking.instantPayouts.settings.content.error.button.refreshPage');
    }
  }
  get isCtaButtonLoading() {
    return this.args.isOnboarding;
  }
  onCtaClick() {
    switch (this.state) {
      case State.GetStarted:
        this.args.onGetStartedClick();
        break;
      case State.LearnMore:
        this.args.onLearnMoreClick();
        break;
      case State.Error:
        theWindow.location.reload();
        break;
    }
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "onCtaClick", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onCtaClick"), _class.prototype)), _class);
export { BankingInstantPayoutsUpsell as default };